import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyDashboardService
 * Client API per la dashboard compliance del modulo Sicurezza.
 */
export default class SafetyDashboardService {
    // id_agenzia opzionale = contesto agenzia selezionato dal manager
    // ("" / null = vista globale aggregata).
    static getKpi = (id_agenzia = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dashboard/kpi`;
            const payload = id_agenzia ? { id_agenzia: Number(id_agenzia) } : {};
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static getTopAziende = (limit = 5, id_agenzia = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dashboard/topAziende`;
            const payload = { limit };
            if (id_agenzia) payload.id_agenzia = Number(id_agenzia);
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    /** Prossime scadenze formative (attestati scaduti o in scadenza). */
    static getScadenze = (limit = 20, id_agenzia = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dashboard/scadenze`;
            const payload = { limit };
            if (id_agenzia) payload.id_agenzia = Number(id_agenzia);
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };
}
